"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  importBillUpload: {
    confirm: '确定',
    blNoTips: '查询规则:提单号(最多50票)多票查询时用半角英文逗号隔开',
    pleaseCheckData: '请勾选数据',
    limit10Data: '一次最多勾选10条记录!',
    blNoAndContainerNo: '提单号：',
    pod: '卸货港',
    bankSlipUploadApplyInvoice: '水单上传/开票申请',
    tips: 'CNTAO港口未开放此功能，如有问题，请联系对应口岸公司相关人员。',
    paymentNo: '付款抬头',
    paymentWay: '付款方式',
    paymentInCny: '折算人民币支付',
    paymentInUsd: '折算美金支付',
    paymentInKrw: '折算韩元支付',
    paymentInHkd: '折算港币支付',
    originalCurrencyPay: '原币支付',
    onlycny: '只开人民币',
    invoiceWay: '开票方式',
    bankSlipDOF: '换单费DOF现场支付',
    extract: '包含进口提柜押金',
    receiveEmail: '接收邮箱',
    address: '地址',
    phone: '电话',
    accountBank: '开户行',
    account: '银行账号',
    bankUsd: '开户银行(USD)',
    accountUsd: '银行账号(USD)',
    invoiceTaxNo: '发票抬头税号',
    remark: '备注',
    emailNotNull: '接收邮箱不能为空',
    addressNotNull: '地址不能为空',
    phoneNotNull: '电话不能为空',
    accountBankNotNull: '开户行不能为空',
    accountNotNull: '银行账号不能为空',
    invoiceTaxNoNotNull: '发票抬头税号不能为空',
    invoiceWayNotNull: '开票方式不能为空',
    paymentNoNotNull: '付款抬头不能为空',
    blNoNotNull: '提单号不能为空',
    podNotNull: '卸货港不能为空',
    saveSuccessfully: '保存成功',
    applicationInProgress: '申请中，请勿重复提交！',
    invoiceAndPaymentAutoProcessing: '该单号已申请开票并接受，无需再上传水单，我司机器人后台会自动获取付款信息并进行销账，请直接关注电放情况即可。',
    noRate: '汇率未完善，请联系管理员！',
    modPaymentNo: '请更改付款抬头为实际付款公司全称',
    extractAmount: '押金:',
    noSecondOpr: '不允许二次操作'
  },
  importBillUploadTable: {
    no: '序号',
    amount: '费用清单金额',
    paymentStatus: '付款状态',
    applyInvoice: '开票申请状态',
    orderNo: '订单号',
    blNo: '提单号',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    voyageLeg: '航段',
    pol: '装货港',
    etd: '预计离港',
    pod: '卸货港',
    eta: '预计抵港',
    del: '目的港',
    bankSlipAuditRemark: '水单审核备注',
    auditRemark: '发票审核备注'
  }
};